import React from 'react';
import { Hero } from './components/Hero';
import { InitialTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { First30Days } from './components/First30Days';
import { MethodOverview } from './components/MethodOverview';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { ValueStack } from './components/ValueStack';
import { EmotionalClose } from './components/EmotionalClose';
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-gold/30 selection:text-brand-gold bg-[#FFF8F2]" data-id="element-0">
      <Hero data-id="element-1" />
      <InitialTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <First30Days data-id="element-4" />
      <MethodOverview data-id="element-5" />
      <Guarantee data-id="element-6" />
      <FAQ data-id="element-7" />
      <CostComparison data-id="element-8" />
      <ValueStack data-id="element-9" />
      <Pricing data-id="element-10" />
      <EmotionalClose data-id="element-11" />
      <Footer data-id="element-12" />
      <FloatingNotification data-id="element-13" />
    </div>;
}